/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

import playSoundFile from "../assets/sounds/bet.mp3";
import distributeSoundFile from "../assets/sounds/deal.mp3";
// import CustomModal from "../components/CustomModal/CustomModal.tsx";

import {
  calculateHandValue,
  createDeck,
  determineWinner,
  handleAcceptInsurance,
  handleDeclineInsurance,
  handleDoubleDown,
  handleGameButtonClick,
  handleHit,
  handleSplit,
  handleStand,
  startGame,
} from "../blackJackServices/blackJackServices";
import Deck from "../components/Deck/Deck";
import Footer from "../components/Footer/Footer";
import GameTable from "../components/GameTable/GameTable";
import Sidebar from "../components/Sidebar/Sidebar";
import { Card, CardSize, ClickState, HandStatus } from "../GameTypes/game.type";
import useCounterStore from "../store/store";
import {
  runAnimation,
  setCardDimensions,
  setDealerHandRef,
  setPlayerHandRef,
  setPlayerSplitHandRef,
  setRef,
} from "../utils/gameUtils";
// import CustomModal from "../components/CustomModal/CustomModal";
// import CustomModal from "../components/CustomModal/CustomModal";

const Game: React.FC = () => {
  const { isMovieMode, liveWageredStatus, liveWageredStatusAction, betAmt } =
    useCounterStore((state) => state);

  const { wagered, profit } = liveWageredStatus;

  const { isSound } = useCounterStore((state) => state);

  const playerSplitHandRef = useRef<HTMLDivElement | null>(null);
  const DeckCardRef = useRef<HTMLDivElement | null>(null);
  const dealerHandRef = useRef<HTMLDivElement | null>(null);
  const playerHandRef = useRef<HTMLDivElement | null>(null);
  const [deck, setDeck] = useState<Card[]>(createDeck());
  const [cardSize, setCardSize] = useState<CardSize>({
    width: 96,
    height: 144,
    gap: 13,
    margin: 0,
  });
  const [hasDoubledDown, setHasDoubledDown] = useState<[boolean, boolean]>([
    false,
    false,
  ]);
  const [playerCards, setPlayerCards] = useState<Card[][]>([[], []]);
  const [dealerCards, setDealerCards] = useState<Card[]>([]);
  const [splitHands, setSplitHands] = useState<boolean>(false);
  const [isSplit, setIsSplit] = useState<boolean>(false);
  const [flippedCards, setFlippedCards] = useState<number[]>([]);
  const [dealingIndex, setDealingIndex] = useState<number>(0);
  const [isDealing, setIsDealing] = useState<boolean>(false);
  const [dealerSecondCardRevealed, setDealerSecondCardRevealed] =
    useState<boolean>(false);
  const [hasPlayerStand, setHasPlayerStand] = useState<boolean[]>([
    false,
    false,
  ]);
  const [gameStatus, setGameStatus] = useState<string>("playing");
  const [handIndex, setHandIndex] = useState<number>(0);
  const [showInsurance, setShowInsurance] = useState<boolean>(false);
  const [gameButtonClicked, setGameButtonClicked] = useState<ClickState>({
    hit: false,
    stand: false,
    split: false,
    double: false,
    play: false,
  });
  const [handStatuses, setHandStatuses] = useState<HandStatus[]>(["", ""]);
  const [hasTakenInsurance, setHasTakenInsurance] = useState<boolean>(false);
  const [insuranceBet, setInsuranceBet] = useState<number>(0);
  // const { isMuted } = useAudio();

  // const {
  //   isSound,
  //   isMovieMode,
  //   isMusic,
  //   setMovieMode,
  //   setIsMusic,
  //   soundAction,
  // } = useCounterStore((state) => state);

  const distributeSound = useRef(new Audio(distributeSoundFile));
  const playSound = useRef(new Audio(playSoundFile));

  useEffect(() => {
    // distributeSound.current.muted = isSound;
    // playSound.current.muted = isSound;

    // if (isSound) {
    distributeSound.current.muted = !isSound;
    playSound.current.muted = !isSound;
    // }
  }, [isSound]);

  useEffect(() => {
    if (dealerCards.length === 2 && dealerCards[0].value === "A") {
      setShowInsurance(true);
    }
  }, [dealerCards]);

  useEffect(() => {
    const primaryTotal = calculateHandValue(playerCards[0]);
    if (primaryTotal > 21) {
      setHasPlayerStand((prev) => {
        const newStand = [...prev];
        newStand[0] = true;
        return newStand;
      });
      setHandStatuses((prev) => {
        const newStatuses = [...prev];
        newStatuses[0] = "lost";
        return newStatuses;
      });
      if (isSplit && playerCards[1].length > 0 && handIndex === 0) {
        setHandIndex(1);
      }
      if (!isSplit || hasPlayerStand[1]) {
        setGameStatus("player lost");
      }
    } else if (primaryTotal === 21) {
      setTimeout(
        () =>
          handleStand(
            handIndex,
            isSplit,
            dealerCards,
            deck,
            dealingIndex,
            setHasPlayerStand,
            setDealerSecondCardRevealed,
            setDealerCards,
            setFlippedCards,
            distributeSound.current,
            (isPlayer, dealerCardCount, handIndex) =>
              runAnimation(
                isPlayer,
                dealerCardCount,
                handIndex,
                playerCards,
                dealingIndex,
                cardSize,
                DeckCardRef,
                dealerHandRef,
                playerHandRef,
                playerSplitHandRef
              )
          ),
        500
      );
    }

    if (isSplit && playerCards[1].length > 0) {
      const splitTotal = calculateHandValue(playerCards[1]);
      if (splitTotal > 21) {
        setHasPlayerStand((prev) => {
          const newStand = [...prev];
          newStand[1] = true;
          return newStand;
        });
        setHandStatuses((prev) => {
          const newStatuses = [...prev];
          newStatuses[1] = "lost";
          return newStatuses;
        });
        if (hasPlayerStand[0]) {
          setGameStatus("player lost");
        } else {
          setHandIndex(0);
        }
      } else if (splitTotal === 21 && handIndex === 1) {
        setHasPlayerStand((prev) => {
          const newStand = [...prev];
          newStand[1] = true;
          return newStand;
        });
        setHandIndex(0);
      } else if (splitTotal === 21 && handIndex === 0 && hasPlayerStand[0]) {
        handleStand(
          handIndex,
          isSplit,
          dealerCards,
          deck,
          dealingIndex,
          setHasPlayerStand,
          setDealerSecondCardRevealed,
          setDealerCards,
          setFlippedCards,
          distributeSound.current,
          (isPlayer, dealerCardCount, handIndex) =>
            runAnimation(
              isPlayer,
              dealerCardCount,
              handIndex,
              playerCards,
              dealingIndex,
              cardSize,
              DeckCardRef,
              dealerHandRef,
              playerHandRef,
              playerSplitHandRef
            )
        );
      }
    }
  }, [playerCards, isSplit, handIndex]);

  useEffect(() => {
    if (
      gameStatus === "player lost" ||
      gameStatus === "player won" ||
      gameStatus === "dealer won" ||
      gameStatus === "draw"
    ) {
      setGameButtonClicked((prev) => ({
        ...prev,
        play: false,
      }));
    }
  }, [gameStatus]);

  useEffect(() => {
    if (hasPlayerStand[0] && (!isSplit || hasPlayerStand[1])) {
      const dealerTotalValue = calculateHandValue(dealerCards, true);

      if (dealerTotalValue >= 17) {
        setTimeout(() => {
          determineWinner(
            dealerTotalValue,
            playerCards,
            isSplit,
            setHandStatuses,
            setGameStatus
          );
        }, 500);
      }
    }
  }, [dealerCards, hasPlayerStand]);

  useEffect(() => {
    if (isDealing && dealingIndex < 4) {
      setGameButtonClicked((prev) => ({
        ...prev,
        hit: true,
        stand: true,
        split: true,
        double: true,
      }));
      const dealCard = setTimeout(() => {
        const newCard = deck[dealingIndex];
        const cardId = Date.now() + dealingIndex;
        const isPlayer = dealingIndex % 2 === 0;

        distributeSound.current.play();
        runAnimation(
          isPlayer,
          dealerCards.length,
          handIndex,
          playerCards,
          dealingIndex,
          cardSize,
          DeckCardRef,
          dealerHandRef,
          playerHandRef,
          playerSplitHandRef
        );

        setTimeout(() => {
          if (isPlayer) {
            setPlayerCards((prev) => {
              const updatedHands = [...prev];
              updatedHands[0] = [
                ...updatedHands[0],
                { ...newCard, id: cardId },
              ];
              return updatedHands;
            });
          } else {
            setDealerCards((prev) => [...prev, { ...newCard, id: cardId }]);
          }
          setFlippedCards((prev) => [...prev, cardId]);

          if (dealingIndex !== 3) {
            setTimeout(() => {
              setFlippedCards((prev) => prev.filter((id) => id !== cardId));
            }, 200);
          }
          setDealingIndex((prev) => prev + 1);
        }, 150);
      }, 300);
      console.log(dealCard);
    } else if (dealingIndex >= 4) {
      setGameButtonClicked((prev) => ({
        ...prev,
        hit: false,
        stand: false,
        split: false,
        double: false,
      }));
      setIsDealing(false);
    }
  }, [dealingIndex, isDealing, deck]);

  useEffect(() => {
    if (isSplit && !hasPlayerStand[0] && hasPlayerStand[1]) {
      setHandIndex(0);
    } else if (isSplit && !hasPlayerStand[1]) {
      setHandIndex(1);
    } else {
      setHandIndex(0);
    }
  }, [isSplit, hasDoubledDown, hasPlayerStand]);

  useEffect(() => {
    if (hasPlayerStand[0] && hasPlayerStand[1] && hasTakenInsurance) {
      const dealerTotal = calculateHandValue(dealerCards, true);

      if (dealerTotal === 21) {
        setGameStatus("insurance won");
      } else {
        setInsuranceBet(0);
      }
    }
  }, [hasPlayerStand]);

  useEffect(() => {
    if (
      isSplit &&
      calculateHandValue(playerCards[0]) === 21 &&
      calculateHandValue(playerCards[1]) === 21
    ) {
      determineWinner(
        calculateHandValue(dealerCards),
        playerCards,
        isSplit,
        setHandStatuses,
        setGameStatus
      );
    }
  }, [isSplit, playerCards]);

  return (
    <div className="game-container-outer">
      {/* <div className="game"> */}
      {/* <div className="game-wrapper"> */}
      {/* <div className="game-layout"> */}
      <div
        className={`${isMovieMode ? "widthfull heightscreen" : "game-layout"} `}
      >
        <div className="game-frame">
          <div className="game-container">
            <Deck
              setRef={(deckCard) => setRef(deckCard, DeckCardRef)}
              cardSize={cardSize}
            />
            <Sidebar
              gameButtonClicked={gameButtonClicked}
              handleGameButtonClick={() =>
                handleGameButtonClick(
                  gameButtonClicked,
                  setGameButtonClicked,
                  () => {
                    const update = wagered + Number(betAmt);
                    liveWageredStatusAction("wagered", update);

                    startGame(
                      playSound.current,
                      setIsDealing,
                      setDeck,
                      setPlayerCards,
                      setDealerCards,
                      setFlippedCards,
                      setDealingIndex,
                      setDealerSecondCardRevealed,
                      setHasPlayerStand,
                      setGameStatus,
                      setHasDoubledDown,
                      setShowInsurance,
                      setHasTakenInsurance,
                      setInsuranceBet,
                      setIsSplit,
                      setSplitHands,
                      setHandIndex,
                      setHandStatuses,
                      setGameButtonClicked
                    );
                  }
                )
              }
              handleHit={() =>
                handleHit(
                  gameStatus,
                  gameButtonClicked,
                  deck,
                  dealingIndex,
                  handIndex,
                  setGameButtonClicked,
                  setPlayerCards,
                  setFlippedCards,
                  setDealingIndex,
                  distributeSound.current,
                  (isPlayer, dealerCardCount, handIndex) =>
                    runAnimation(
                      isPlayer,
                      dealerCardCount,
                      handIndex,
                      playerCards,
                      dealingIndex,
                      cardSize,
                      DeckCardRef,
                      dealerHandRef,
                      playerHandRef,
                      playerSplitHandRef
                    ),
                  dealerCards
                )
              }
              handleStand={() =>
                handleStand(
                  handIndex,
                  isSplit,
                  dealerCards,
                  deck,
                  dealingIndex,
                  setHasPlayerStand,
                  setDealerSecondCardRevealed,
                  setDealerCards,
                  setFlippedCards,
                  distributeSound.current,
                  (isPlayer, dealerCardCount, handIndex) =>
                    runAnimation(
                      isPlayer,
                      dealerCardCount,
                      handIndex,
                      playerCards,
                      dealingIndex,
                      cardSize,
                      DeckCardRef,
                      dealerHandRef,
                      playerHandRef,
                      playerSplitHandRef
                    )
                )
              }
              handleDoubleDown={() =>
                handleDoubleDown(
                  gameStatus,
                  playerCards,
                  handIndex,
                  hasDoubledDown,
                  isSplit,
                  deck,
                  dealingIndex,
                  setHasDoubledDown,
                  setGameButtonClicked,
                  setPlayerCards,
                  setFlippedCards,
                  setDealingIndex,
                  distributeSound.current,
                  (isPlayer, dealerCardCount, handIndex) =>
                    runAnimation(
                      isPlayer,
                      dealerCardCount,
                      handIndex,
                      playerCards,
                      dealingIndex,
                      cardSize,
                      DeckCardRef,
                      dealerHandRef,
                      playerHandRef,
                      playerSplitHandRef
                    ),
                  () =>
                    handleStand(
                      handIndex,
                      isSplit,
                      dealerCards,
                      deck,
                      dealingIndex,
                      setHasPlayerStand,
                      setDealerSecondCardRevealed,
                      setDealerCards,
                      setFlippedCards,
                      distributeSound.current,
                      (isPlayer, dealerCardCount, handIndex) =>
                        runAnimation(
                          isPlayer,
                          dealerCardCount,
                          handIndex,
                          playerCards,
                          dealingIndex,
                          cardSize,
                          DeckCardRef,
                          dealerHandRef,
                          playerHandRef,
                          playerSplitHandRef
                        )
                    ),
                  dealerCards
                )
              }
              hasDoubledDown={hasDoubledDown}
              playerCards={playerCards}
              showInsurance={showInsurance}
              handleAcceptInsurance={() =>
                handleAcceptInsurance(
                  setHasTakenInsurance,
                  setInsuranceBet,
                  setShowInsurance
                )
              }
              handleDeclineInsurance={() =>
                handleDeclineInsurance(setShowInsurance)
              }
              disableActions={
                dealerCards.length < 2 ||
                playerCards[0].length < 2 ||
                !hasPlayerStand ||
                !hasDoubledDown ||
                gameStatus === "player lost" ||
                gameStatus === "player won" ||
                gameStatus === "dealer won" ||
                gameStatus === "draw"
              }
              handleSplit={() =>
                handleSplit(
                  playerCards,
                  deck,
                  dealingIndex,
                  setIsSplit,
                  setPlayerCards,
                  setFlippedCards,
                  setDeck,
                  setDealingIndex,
                  distributeSound.current,
                  (isPlayer, dealerCardCount, index) =>
                    runAnimation(
                      isPlayer,
                      dealerCardCount,
                      index,
                      playerCards,
                      dealingIndex,
                      cardSize,
                      DeckCardRef,
                      dealerHandRef,
                      playerHandRef,
                      playerSplitHandRef
                    ),
                  dealerCards
                )
              }
            />
            <GameTable
              handStatuses={handStatuses}
              setCardSize={(size) => setCardDimensions(size, setCardSize)}
              cardSize={cardSize}
              setDealerHandRef={(target) =>
                setDealerHandRef(target, dealerHandRef)
              }
              setPlayerHandRef={(target) =>
                setPlayerHandRef(target, playerHandRef)
              }
              setPlayerSplitHandRef={(target) =>
                setPlayerSplitHandRef(target, playerSplitHandRef)
              }
              playerCards={playerCards}
              dealerCards={dealerCards}
              flippedCards={flippedCards}
              playerTotal={calculateHandValue(playerCards[0])}
              playerSplitTotal={calculateHandValue(playerCards[1])}
              dealerTotal={calculateHandValue(
                dealerCards,
                dealerSecondCardRevealed
              )}
              dealerSecondCardRevealed={dealerSecondCardRevealed}
              gameStatus={gameStatus}
              isSplit={isSplit}
              handIndex={handIndex}
              splitHands={splitHands}
              hasPlayerStand={hasPlayerStand}
            />
          </div>

          <Footer />
          {/* <div className="game-footer">
              <BottomNavbar />
            </div> */}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Game;
